<aside class="side-menu" [style.width]="isSideMenuOpen ? '169px' : '60px'">
  <img
    class="toggle-button"
    src="svgs/side-menu/side-menu-toggle.svg"
    alt="toggle button"
    [style.left]="isSideMenuOpen ? '156px' : '46px'"
    [style.right]="isSideMenuOpen ? '156px' : '46px'"
    [style.transform]="
      isRtl()
        ? isSideMenuOpen
          ? 'rotate(0deg)'
          : 'rotate(180deg)'
        : isSideMenuOpen
        ? 'rotate(180deg)'
        : 'rotate(0deg)'
    "
    (click)="openCloseSideMenu()"
  />
  <section class="logo-container">
    <figure>
      <img src="svgs/side-menu/eduminty.svg" alt="EduMinty logo" />
    </figure>
    @if (isSideMenuOpen) {
    <p style="color: #373737; font-weight: bold">AOL</p>
    } @else {
    <p style="font-size: 13px !important">AOL</p>
    }
  </section>
  <nav class="main-nav-list">
    <ul>
      @for (sideMenuItem of sideMenuItems; track sideMenuItem; let index =
      $index) { @if (isRoleAllowedToItem(sideMenuItem.roles)) { @if
      (isSideMenuOpen) {
      <li>
        <a
          [routerLink]="sideMenuItem.route[0]"
          [ngClass]="{ active: isCurrentRouteActive(sideMenuItem) }"
          ariaCurrentWhenActive="page"
          [style.width]="isSideMenuOpen ? '90%' : 'fit-content'"
          (mouseenter)="itemOnHover = index"
          (mouseleave)="itemOnHover = -1"
        >
          <img
            [src]="getSideMenuItemIcon(sideMenuItem)"
            [alt]="sideMenuItem.alt"
          />

          <span [hidden]="!isSideMenuOpen">{{
            sideMenuItem.translationPath | translate
          }}</span>
        </a>
      </li>
      } @else {
      <li
        [appShowFullText]="sideMenuItem.translationPath | translate"
        [placement]="'common.inline-end' | translate"
      >
        <a
          [routerLink]="sideMenuItem.route[0]"
          [ngClass]="{ active: isCurrentRouteActive(sideMenuItem) }"
          ariaCurrentWhenActive="page"
          [style.width]="isSideMenuOpen ? '90%' : 'fit-content'"
          (mouseenter)="itemOnHover = index"
          (mouseleave)="itemOnHover = -1"
          [style.padding-inline-start]="'0.6em'"
        >
          <img
            [src]="getSideMenuItemIcon(sideMenuItem)"
            [alt]="sideMenuItem.alt"
          />

          <span [hidden]="!isSideMenuOpen">{{
            sideMenuItem.translationPath | translate
          }}</span>
        </a>
      </li>
      } } }
    </ul>
  </nav>
  <hr style="width: 82%; margin: 0 auto" />
  <nav class="secondary-nav-list">
    <ul>
      @if (this.showMintyHub() === true) {
      <li>
        <a
          [href]="link"
          routerLinkActive="active"
          ariaCurrentWhenActive="page"
          class="secondary-side-menu-item"
          [style.width]="isSideMenuOpen ? '90%' : 'fit-content'"
        >
          <img src="svgs/side-menu/mintyhub.svg" alt="MintyHub" class="image" />
          <span [hidden]="!isSideMenuOpen">{{ "MintyHub" | translate }}</span>
        </a>
      </li>
      }

      <li (click)="logout()">
        <a
          routerLinkActive="active"
          ariaCurrentWhenActive="page"
          class="secondary-side-menu-item"
          [style.width]="isSideMenuOpen ? '90%' : 'fit-content'"
        >
          <img src="svgs/side-menu/logout.svg" alt="Logout" class="image" />

          <span [hidden]="!isSideMenuOpen">{{
            "sideMenu.logout" | translate
          }}</span>
        </a>
      </li>
    </ul>
  </nav>
</aside>
